/**
 * Whose fee is a session's fixed-fee line (Tier 2)?
 *
 * `cost.flat_fee` means two different things depending on when the
 * session started:
 *   - PINNED (`connection_fee_at_start_cents` is a number, 0 included):
 *     the session pinned EVI's connection fee at start, and
 *     `cost.flat_fee` IS that fee as billed. It is EVI's, kept whole,
 *     never the host's — so it is labelled "Connection fee (EVI)".
 *   - LEGACY (null or absent): the tariff's own session fee from before
 *     the pin existed, the operator's or host's. It keeps its old
 *     "Session fee" label; relabelling it would call a pre-Tier-2 host
 *     fee EVI's.
 *
 * Shared by the session detail page and the receipt PDF so the two can
 * never label the same line differently. Pure; no i18n here — the page
 * translates, the PDF is English-only.
 */

export interface SessionFeeLine {
  kind: 'connection' | 'session';
  cents: number;
}

/** The fee line to render, or null when the session carried no fee. */
export function sessionFeeLine(session: {
  connection_fee_at_start_cents?: number | null;
  cost?: { flat_fee?: number | null } | null;
}): SessionFeeLine | null {
  const cents = Math.round(session.cost?.flat_fee ?? 0);
  if (!(cents > 0)) return null;
  return {
    kind: typeof session.connection_fee_at_start_cents === 'number' ? 'connection' : 'session',
    cents,
  };
}
